<template>
  <q-layout view="lhh LpR lff">
    <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
    <q-page-container v-if="pageLoad">
      <q-page padding>
        <div class="row justify-between">
          <q-btn class="q-ma-xs q-pr-md justify-left" ripple dense flat color="black" @click="dialogExit = true">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
          <q-btn :loading="load" ripple icon="save" flat color="black" @click="dialogSubmit = true" size="20px"/>
        </div>
        <div class="text-h5 text-center q-py-md">Tải lên nhật ký thực hiện công việc</div>
        <q-card class="q-my-xs q-pa-md" >
            <div class="row">
              <div class="col-12 col-md-4 row items-center">
                <div class="row items-center">
                  <input type="file" ref="upload" style="display:block" v-on:input="chooseFile" :accept="acceptFileType.join(',')"/>
                  <q-btn ripple icon="cloud_upload" flat color="black" size="20px" @click="upload" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-4 q-mx-xs">
                  <div class="row">
                    <q-input class="col-10 self-center" v-model="modelDate" label="Ngày" readonly></q-input>
                    <q-btn icon="event" size="22px" style="height: 25%" flat class="col-2 cursor-pointer" @click="datePopUp = false">
                      <q-popup-proxy>
                        <q-date v-model="value" minimal v-close-popup="datePopUp"/>
                      </q-popup-proxy>
                    </q-btn>
                  </div>
              </div>
            </div>
        </q-card>

      <!-- Exit -->
      <q-dialog v-model="dialogExit" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar color="black" text-color="white">?</q-avatar>
            <span class="q-ml-sm">Bạn có muốn thoát ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup to="/tasks"/>
          </q-card-actions>
        </q-card>
      </q-dialog>

      <!-- Submit Data -->
      <q-dialog v-model="dialogSubmit" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="save" color="black" text-color="white"/>
            <span class="q-ml-sm">Bạn có muốn lưu ?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn ripple flat icon="clear" v-close-popup/>
            <q-btn ripple flat icon="done"  v-close-popup @click="submitData()"/>
          </q-card-actions>
        </q-card>
      </q-dialog>

      <q-table
        :data="modelForShow.details"
        :columns="headers"
        row-key="name"
        no-data-label="Không có dữ liệu"
        :key="tableKey"
        :pagination= {rowsPerPage:0}
        :hide-bottom="!_.isEmpty(modelForShow.details)"
        >
        <template v-slot:top-right="props">
          <!-- <q-btn ripple dense icon="add" color="black" flat @click="addItem()" class="q-mr-md"/> -->
        </template>
        <template v-slot:body ="props">
          <q-tr :props="props" v-if="props.row.deleted !== true">
            <q-td >{{ props.row.__index + 1}}</q-td>
            <q-td v-if="props.colsMap.supervisor" class="label-xs-right text-center">{{props.row.supervisor }}</q-td>
            <q-td v-if="props.colsMap.farm" class="label-xs-right text-center">{{props.row.farm ? $getNameById(farms,props.row.farm,'name'): ''}}</q-td>
            <q-td v-if="props.colsMap.lot" class="label-xs-right text-center">{{props.row.lot ? $getNameById($getNameById(farms,props.row.farm,'listLot'),props.row.lot,'name'): ''}}</q-td>
            <q-td v-if="props.colsMap.job" class="label-xs-right text-center">{{props.row.job ? $getNameById(jobs,props.row.job,'name'): ''}}</q-td>
            <q-td v-if="props.colsMap.category" class="label-xs-right text-center">{{props.row.job ? $getNameById(jobStore.categories, $getNameById(jobs,props.row.job,'jobCategory'), 'name') : ''}}</q-td>
            <q-td v-if="props.colsMap.type" class="label-xs-right text-center">{{props.row.type ? $getNameById(workerTypes,props.row.type,'label'): ''}}</q-td>
            <q-td v-if="props.colsMap.number" class="label-xs-right text-center">{{ props.row.number}}</q-td>
            <q-td v-if="props.colsMap.weight" class="label-xs-right text-center">{{ props.row.weight}}</q-td>
            <q-td v-if="props.colsMap.meka" class="label-xs-right text-center">{{props.row.meka ? $getNameById(mekaStore.list,props.row.meka,'displayName'): ''}}</q-td>
            <q-td v-if="props.colsMap.note" class="label-xs-right text-center">{{ props.row.note}}</q-td>
            <q-td v-if="props.colsMap.actions" class="label-xs-right text-center">
              <q-btn ripple flat round color="black" icon="edit" @click="clickEditButton(props)" />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import moment from 'moment'
import { firebase } from '@firebase/app'
import { date } from 'quasar'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
// eslint-disable-next-line
const { Timestamp } = firebase.firestore
// eslint-disable-next-line
import _ from 'lodash'
export default {
  data() {
    return {
      acceptFileType: [
        '.xls',
        '.xlsx',
        '.csv',
      ],
      defaultDateFormat: 'DD/MM/YYYY',
      showDateFormat: 'DD/MM/YYYY HH:MM Z',
      yearMonthFormat: 'YYYYMM',
      quasarFormat: 'YYYY/MM/DD',
      value: '',
      uploadData: [],
      modelDate: null,
      datePopUp: false,
      model: {},
      dialogExit: false,
      dialogEdit: false,
      dialogDel: false,
      dialogSubmit: false,
      dialogUpload: true,
      camIsOn: false,
      pageLoad: false,
      tableKey: 0,
      roles: null,
      dialogKey: 1,
      modelKey: 2,
      load : false,
      tasks: {},
      supervisors: [],
      modelForShow: {
      },
      isAdding: false,
      selectedRowIndex: -1,
      workerTypes: [
        {
          label: 'Công nhật',
          value: 'congnhat',
          id: 'congnhat'
        },
        {
          label: 'Công khoán',
          value: 'khoan',
          id: 'khoan'
        }
      ],
      farms: [],
      headers: [{
          label: "No",
          align: "left",
          name: "no"
        },
        {
          label: "Giám sát",
          align: "center",
          name: "supervisor"
        },
        {
          label: "Nông trường",
          align: "center",
          name: "farm"
        },
        {
          label: "Lô",
          align: "center",
          name: "lot"
        },
        {
          label: "Công việc",
          align: "center",
          name: "job"
        },
        {
          label: "Loại công việc",
          align: "center",
          name: "category"
        },
        {
          label: "Loại nhân công",
          align: "center",
          name: "type"
        },
        {
          label: "Số lượng",
          align: "center",
          name: "number"
        },
        {
          label: "Khối lượng",
          align: "center",
          name: "weight"
        },
        {
          label: "Nhân công",
          align: "center",
          name: "meka"
        },
        {
          label: "Ghi chú",
          align: "center",
          name: "note"
        },
      ],
      csvDetailsFields: [
        {
        label: 'STT',
        },
        {
        label: 'Ngày',
        value: 'date',
        key: 'date',
        type: 'date',
        required: true
        },
        {
        label: 'Giám sát',
        value: 'supervisor',
        key: 'supervisor',
        required: true
        },
        {
        label: 'Nông trường',
        value: 'farm',
        key: 'farm',
        required: true,
        type: {
          showLabel: 'name',
          listToFind: 'vm.farmStore.list'
          }
        },
        {
        label: 'Lô',
        value: 'lot',
        key: 'lot',
        type: 'number',
        required: true
        },
        {
        label: 'Mã CV',
        value: 'job',
        key: 'job',
        required: true,
        type: {
          showLabel: 'jobCode',
          listToFind: 'vm.jobStore.list'
          }
        },
        {
        label: 'Loại nhân công',
        value: 'jobType',
        key: 'type',
        required: true,
        type: {
          showLabel: 'label',
          listToFind: 'vm.workerTypes'
          }
        },
        {
        label: 'Số lượng',
        value: 'workerNumber',
        key: 'number',
        required: true,
        type: 'number',
        },
        {
        label: 'Nhân công',
        value: 'workerMeka',
        key: 'meka',
        required: true,
        type: {
          showLabel: 'displayName',
          listToFind: 'vm.mekaStore.list'
          }
        },
        {
        label: 'Khối lượng',
        value: 'weight',
        key: 'weight',
        required: true,
        type: 'number',
        },
        {
        label: 'ĐVT',
        value: 'unit',
        },
        {
        label: 'Ghi chú',
        value: 'note',
        key: 'note',
        }
      ],
    }
  },
  async mounted() {
    let vm = this
    try {
      vm.loading(true)
      vm.$nextTick(() => {
        vm.$refs.bar ? vm.$refs.bar.start() : null
      })
      let f = vm.farmStore
      let j = vm.jobStore
      let m = vm.mekaStore
      let r
      let s
      vm.roles = vm.permission.roles
      //check roles
      const regexFarm = /(^F[0-9]M$)/
      let fm = Object.keys(vm.roles).filter((item) => regexFarm.test(item))
      if(vm.roles.hasOwnProperty('BOM') || !this._.isEmpty(fm)) {
        s = await this.$query(['Users'],[['roles.SUPVR','==',true]])
      }

      Promise.all([f, j, m, r, s]).then(res => {
        try {
          res.forEach(item => {
            if (item && item.hasOwnProperty('error'))
              throw item.error
          })
          vm.farms = res[0].list
          vm.jobs = res[1].list ? res[1].list.sort((a, b) => a.name.localeCompare(b.name)) : []
          vm.mekas = res[2].list ? res[2].list.sort((a, b) => a.displayName.localeCompare(b.displayName)) : []
          vm.supervisors = res[4] ? res[4].data : []
          vm.value = date.formatDate(new Date(), this.quasarFormat)

          vm.modelDate = !vm.modelForShow.date ? date.formatDate(new Date(), vm.defaultDateFormat) : date.formatDate(this.modelForShow && this.modelForShow.date instanceof firebase.firestore.Timestamp ? this.modelForShow.date.toDate() : '', this.defaultDateFormat)
          vm.pageLoad = true
          vm.$refs.bar ? vm.$refs.bar.stop() : null
          }
        catch (er) {
          vm.$refs.bar.stop()
          vm.$q.notify({
            message: er.message,
            color: 'red',
            icon: 'error'
          })
        }
      })
    } catch (error) {
      vm.$refs.bar.stop()
      vm.$q.notify({
        message: error.message,
        color: 'red',
        icon: 'error'
      })
    }
    vm.loading(false)
  },
  watch: {
    'modelForShow.details': {
      // eslint-disable-next-line no-unused-vars
      handler: function(newVal, oldVal) {
        let vm = this
        vm.tableKey++
      },
      deep: true
    },
    'value': {
      handler: function(newVl, oldVl) {
        let newVlMoment = moment(newVl, this.quasarFormat)
        let oldVlMoment = moment(oldVl, this.quasarFormat)
        this.modelDate = date.formatDate(newVl, this.defaultDateFormat)
        this.datePopUp = !oldVl ? (newVlMoment.date() !== oldVlMoment.date() ? true 
          : newVlMoment.month() !== oldVlMoment.month() || newVlMoment.year() !== oldVlMoment.year()) 
            : true
        this.modelForShow.details = []
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters([
      'user',
      'permission',
      'isAnonymous',
      'farmStore',
      'mekaStore',
      'jobStore'
    ]),
  },
  methods: {
    loading(isLoad) {
      this.load = isLoad
    },
    addItem() {
      this.$refs.farm.$emit('submitEvent', this.modelForShow.farm)
      this.$nextTick(() => {
        if (!this.errors.has('farm'))
        {
          this.resetData()
          this.isAdding = true
          this.dialogEdit = true
          this.model.lots = this._.cloneDeep(this._.omit(this.lots,['area','total','name']))
          this.$nextTick(() => {
            this.dialogKey++
          })
        }
        else {
          this.$q.notify({
            message: 'Vui lòng thử lại',
            color: 'red',
            icon: 'error'
          })
        }
      })
    },
    // eslint-disable-next-line
    filterJob(val, update, abort) {
      let vm = this
      update(() => {
        if (val === '') {
          this.jobOptions = vm.jobs
        }
        else {
          const needle = val.toLowerCase()
          this.jobOptions = vm.jobs.filter(v => (
              (v.name && v.name.toLowerCase().indexOf(needle) > -1) ||
              (v.jobCode && v.jobCode.toLowerCase().indexOf(needle.replace(/\s/g, '')) > -1)
            ))
        }
      })
    },
    // eslint-disable-next-line
    filterMeka(val, update, abort) {
      let vm = this
      update(() => {
        if (val === '') {
          this.mekaOptions = vm.mekas
        }
        else {
          const needle = val.toLowerCase()
          this.mekaOptions = vm.mekas.filter(v => (
              (v.displayName && v.displayName.toLowerCase().indexOf(needle) > -1) ||
              (v.email && v.mekaId.toLowerCase().indexOf(needle.replace(/\s/g, '')) > -1) ||
              (v.mekaId && v.mekaId.toLowerCase().indexOf(needle.replace(/\s/g, '')) > -1) ||
              (v.email && v.email.toLowerCase().indexOf(needle.replace(/\s/g, '')) > -1)
            ))
        }
      })
    },
    upload() {
      let vm = this
      try {
        if (!vm.uploadData || vm._.isEmpty(vm.uploadData) ) throw new Error("Dữ liệu rỗng")

      //validate on headers
      if (!vm.validateUploadKeys(vm.uploadData[0])) {
        throw new Error('Dữ liệu cột không đúng')
      }

      //filter by date
      let dataFilteredByDate = vm._.groupBy(vm.uploadData,'Ngày')[vm.modelDate]
      
      // data length diff from filter data then has a diff date error
      if (!dataFilteredByDate || dataFilteredByDate.length !== vm.uploadData.length)
        throw new Error("Dữ liệu ngày không khớp")

      let dataFilteredByRoles = vm.filterByRoles(dataFilteredByDate)
      let data = []
      let rowData = {}

      dataFilteredByRoles.forEach(row => {
      //maping uploadData label with csvFields key
          rowData = {}
        vm.csvDetailsFields.forEach(field => {
            if (field.key) {
              //if field value itself
              if (!field.type) {
                rowData[field.key] = row[field.label]
              }
              else {
                let f = null
                try {
                  //if field value is a number
                  if (field.type === 'number') {
                    // let regex = '^[a-zA-Z]*$'
                    //if value of 'field.label' is 'number'
                    if (typeof row[field.label] === 'number') f = row[field.label]
                    //
                    else if (!vm._.isEqual(row[field.label], '') && (row[field.label] !== null || row[field.label] !== undefined))//!row[field.label].matches(regex)
                    {
                        f = parseFloat(row[field.label])
                    }
                    else {
                      throw new Error(`${field.label} ${row[field.label] ? (row[field.label]) : 'Giá trị rỗng'}`)
                    }
                  }

                  //if field value is date type
                  else if (field.type === "date") {
                    f = Timestamp.fromDate(moment.utc(row[field.label], 'DD/MM/YYYY').toDate())
                  }

                  //if field value is an array
                  // else if (field.type === 'array') {
                  //     f = row[field.label] ? JSON.parse('['+row[field.label]+']') : []
                  // }

                  //if field value is an object
                  else if (vm._.isEqual(typeof field.type, 'object')) {
                    f = vm._.find(eval(field.type.listToFind),{[field.type.showLabel]:row[field.label]}).id
                  }

                  //assign f for rowdata 
                  rowData[field.key] = f
                  
                }
                catch (err) {
                  //if parsing error
                  throw new Error(`${field.label} ${row[field.label] ? row[field.label] : 'Giá trị rỗng'}`)
                }
              }
            //if required field is empty
            if (field.required && (rowData[field.key] === null || rowData[field.key] === undefined)) {
              throw new Error(`${field.label} ${row[field.label] ? row[field.label] : 'Giá trị rỗng'}`)
            }
          }
        })
        
        vm.validateUploadRowData(rowData)
          data.push(rowData)
      });
        vm.modelForShow.details = data
        vm.tableKey++
        vm.$q.notify({
          message: `Tải thành công ${vm.modelForShow.details.length} dữ liệu`,
          color: 'green',
          icon: 'done'
        })
      }
      catch (err) {
        vm.$q.notify({
          message: 'Không thể tải: ' + err.message,
          color: 'red',
          icon: 'error'
        })
      }
    },
    chooseFile(event) {
      let vm = this
      try {
        let input = event.target
        let reader = new FileReader()
        reader.onload = function() {
          let fileData = reader.result
          let wb = XLSX.read(fileData, {type : 'binary'})
          let rowObj = XLSX.utils.sheet_to_row_object_array(wb.Sheets[wb.SheetNames[0]])
          vm.uploadData = rowObj
        }
        reader.readAsBinaryString(input.files[0])
      }
      catch(err) {
        vm.uploadData = null
      }
    },
    validateUploadKeys(row) {
      let vm = this
      let valid = true
      vm.csvDetailsFields.forEach(field => {
        //if field has key then add it
        if(field.key) {
          if (field.required) {
            if (!row[field.label] || row[field.label] == undefined) {
              valid = false
              }
          }
        }
      })
      return valid
    },
    validateUploadRowData(rowData) {
      let vm = this
      let required = vm._.cloneDeep(vm.csvDetailsFields)
      required.forEach(field => {
        if (field.key && field.required) {
          //validate on required but empty fields
          if (!rowData[field.key])
            throw new Error(`Giá trị ${field.key} rỗng`)
            //validate on supervisor
          if (field.key === "supervisor")
          {
            let findSup
            if (vm.roles.SUPVR) {
              findSup = true
            }
            else if (!vm.roles.BOM)
            {
              findSup = vm._.find( vm.supervisors, {_id:rowData[field.key]}) || rowData[field.key] === vm.user.email
            }
            if (!findSup && !vm.roles.BOM )
              throw new Error(`Không thể tải: Giám sát ${rowData[field.key]}`)
          }
        }
      })
    },
    filterByRoles(data) {
      let vm = this
      let roles = vm.permission.roles
      if (roles['BOM'] === true ) {
        return data
      }
      if (roles['SUPVR'] === true ) {
        let finalData = vm._.groupBy(data, "Giám sát")[vm.user.email]
        if (data.length !== finalData.length) throw Error("Giám sát không khớp")
        return finalData
      }
      else {
        const regexFarm = /(^F[0-9]M$)/
        let regexNumber = /\d+/g
        let fm = Object.keys(roles).filter((item) => regexFarm.test(item))
        let farmGroup = vm._.groupBy(data, "Mã nông trường")
        let finalData = []
        vm._.forEach(fm, item => {
           finalData = finalData.concat(farmGroup[vm.$getNameById(vm.farms,parseFloat(item.match(regexNumber)), 'farmCode')])
          })
        if (!data || finalData && finalData.length !== data.length) {
          throw new Error("Nông trường không khớp")
        }
        return finalData
      }
    },
    submitData() {
      let vm = this
      vm.loading(true)
      // console.log(vm.initDataForSubmit())
      let submitModel = { data: vm.initDataForSubmit()}
      vm.$command.execute('uploadTasks', submitModel).then( () => {
        vm.loading(false)
        vm.$q.notify({
          message: 'Đã lưu thành công',
          color: 'black',
          icon: 'check'
        })
        vm.$router.push('/tasks')
        }).catch((error) => {
          vm.loading(false)
          vm.$q.notify({
            message: 'Lưu thất bại: ' + error.message,
            color: 'red',
            icon: 'error'
          })
        })
    },
    initDataForSubmit() {
      let vm = this
      let dataSubmit = []
      let jobGroup = vm._.groupBy(vm.modelForShow.details, 'job')

      //group by farm
      vm._.forEach(jobGroup, (value) => {
        let jobGroup = vm._.groupBy(value, 'type')
        //group by job type
        vm._.forEach(vm._.cloneDeep(jobGroup), (job) => {
          let detailsFormat = {}
          detailsFormat.deleted = false
          detailsFormat.date = job[0].date//Timestamp.fromDate(moment.utc(job[0].date, vm.defaultDateFormat).toDate())
          detailsFormat.farm = job[0].farm
          detailsFormat.job = job[0].job
          detailsFormat.supervisor = job[0].supervisor
          detailsFormat.worker = {
            number: job[0].number,
            type: job[0].type,
            meka : job[0].meka
          }
          detailsFormat.yearMonth = moment.utc(vm.modelDate, 'DD/MM/YYYY').format('YYYYMM')
          detailsFormat.totalWeight = vm._.sumBy(job, (o) => o.weight)
          detailsFormat.details = []
          //add row details
          vm._.forEach(vm._.cloneDeep(job), (row) => {
            detailsFormat.details.push({
              lot: row.lot,
              weight: row.weight,
              note: row.note
            })
          })
        dataSubmit.push(detailsFormat)
        })
      })
      return dataSubmit
    },
    moment(timestamp) {
      return moment(timestamp)
    },
    firebase() {
      return firebase
    }
  }
}
</script>
